import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import App from "./App";
import { VerificationDataProvider } from "./context/VerificationDataContext";
import { DataProvider } from "./context/DataContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <VerificationDataProvider>
      <DataProvider>
        <App />
      </DataProvider>
    </VerificationDataProvider>
  </React.StrictMode>
);
